<script setup>
import { ref, defineProps, onBeforeUnmount,defineEmits, onMounted } from 'vue';
import { useUsers } from '@/composables/useUsers';
import axios from '@/plugins/axios';
import eventBus from '@/utils/eventBus';
import { useUserStore } from '@/stores/userStore';
import { showToast } from '@/utils/toaster';
import router from '@/router';
import userService from '@/services/userServices';
const emit = defineEmits(['toggle']);

defineProps({
  show: Boolean,
});

const toggleModal = () => {
  emit('close');
};
onMounted(()=>{
  eventBus.toggleModal = toggleModal;
});

const userStore= useUserStore();
const inputs = ref(['', '', '', '','','']); // Adjust the number of inputs as needed
const timer = ref(30); // Start with 30 seconds
const isButtonDisabled = ref(true); // Initially disable the button
let intervalId = null; // Variable to hold the interval ID
const backspaceCounter = ref(0); // Tracks backspace presses
const isOtpSectionActive = ref(false);
const username=ref('')
const password=ref('')
const accessToken= userStore.getAccessToken;

const getUserDetails = async ()=>{
  try {
        // const response = await axios.get(process.env.VUE_APP_BASE_API_URL+'/users/profile',
        //   {
        //     headers: {
        //       Authorization: `Bearer ${accessToken}`,
        //     },
        //   }
        // );
        //   const mcano = response.data.profile.mca_no;
        //   userStore.setmcano(mcano);

        //   const type = response.data.profile.type;
        //   userStore.setType(type);

        //   const fssai = response.data.profile.fssai;
        //   userStore.setfssai(fssai);
        console.log("accessToken accessToken", accessToken);
        const profileData = await userService.getUserDetails(accessToken);
        // this.populateData(profileData.profile);
        this.userStore.setmcano(profileData.profile.mca_no); 
        this.userStore.setType(profileData.profile.type);
        this.userStore.setfssai(profileData.profile.fssai);
} catch (error) {
        console.error('Error fetching profile data:', error);
      }
};
const signin =async()=>{
  const {userLogin,error}=useUsers(axios);
  const response =await userLogin(username.value,password.value);
  if(response){
    console.log("login modal", response);
    if(response.accessToken!='' && response.refreshToken!=''){
      await getUserDetails();
      // alert(count);
      // alert(response.accessToken);
      showToast('loginSuccess');
      // window.location.href="/app/home";
      if(userStore.getuserType===1){
        router.push('/app/home');
      }else{
        window.location.reload();
        router.push('/');
      }
      
      // window.location.reload(); // Redirect to /app/home
    } else {
      showToast('loginFailed');
    }
  }else{
    if(error.value!='' || error.value!=null){
      // alert('12'+error.value)
      showToast('loginFailed');
    }
  }
};
// Function to validate the input to allow only digits
const getOtp = ()=>{
  startTimer();
  isOtpSectionActive.value = true;
}
const digitValidate = (index) => {
  inputs.value[index] = inputs.value[index].replace(/[^0-9]/g, '');
};

// Function to handle keydown events for backspace and tab
const handleKeydown = (event, index) => {
  if (event.key === 'Backspace') {
    if (inputs.value[index] === '') {
      backspaceCounter.value++;
      if (backspaceCounter.value >= 2 && index > 0) {
        const prevInput = document.querySelector(`#input${index - 1}`);
        prevInput?.focus();
        backspaceCounter.value = 0;
      }
    }
  } else if (event.key === 'Tab') {
    event.preventDefault();
    if (index < inputs.value.length - 1) {
      const nextInput = document.querySelector(`#input${index + 1}`);
      nextInput?.focus();
    }
  } else {
    backspaceCounter.value = 0;
  }
};

// Function to start the timer
const startTimer = () => {
  if (intervalId) clearInterval(intervalId); // Clear any existing interval
  timer.value = 30; // Reset the timer to 30 seconds
  isButtonDisabled.value = true; // Disable the button

  intervalId = setInterval(() => {
    if (timer.value > 0) {
      timer.value -= 1;
    } else {
      clearInterval(intervalId); // Stop the timer when it reaches 0
      isButtonDisabled.value = false; // Enable the button
    }
  }, 1000); // Run every 1 second (1000 ms)
};

// Function to handle OTP submission
const submitOtp = () => {
  alert('OTP submitted: ' + inputs.value.join(''));
};

// Start the timer on component mount
// onMounted(() => {
//   startTimer();
// });

// Clean up the interval on component unmount
onBeforeUnmount(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
});
// State to manage password visibility
const passwordVisible = ref(false);

const togglePasswordVisibility = () => {
  passwordVisible.value = !passwordVisible.value;
};

const toggleSignUp = ref(false);
const isOtpActive = ref(false);

const toggleLoginMethod = (method) => {
  isOtpActive.value = method === 'otp';
};
</script>

<template>
  <!-- <Transition name="modal"> -->
    <div v-if="show" class="modal-mask">
      <section>
    <div class="container" :class="{active:toggleSignUp}" style="max-width:95vw;">
      <div @click="toggleModal" style="position:relative;z-index:324;cursor: grab; background-color: rgb(193 186 186 / 30%);right: -11px;top: 4px;float:right; border-radius: 100%; display: flex; justify-content: center; padding: 17px; width: 10px; height: 10px; align-items: center;">
        <span>X</span>
      </div>
      <div class="user signinBx">
          <!-- <div class="imgBx">
            <img loading="lazy"
            src="~@/assets/common/images/wqa/login-side-img.webp" 
              alt=""
            />
          </div> -->
          <div class="formBx">
            <div class="login-options">
              <!-- <div
                class="slider"
                :class="isOtpActive ? 'active-otp' : 'active-userid'"
              ></div> -->
              <div
                class="option"
                :class="{ active: !isOtpActive }"
                @click="toggleLoginMethod('userid')"
              >
                Login with MA No
              </div>
              <div
                class="option"
                :class="{ active: isOtpActive }"
                @click="toggleLoginMethod('otp')"
              >
                Login with OTP
              </div>
            </div>

            <form action="" class="form-section" onsubmit="return false;">
              <h2 v-if="isOtpActive" style="text-transform: none;font-size:22px;font-weight:800;">Login with OTP</h2>
              <h2 v-else style="text-transform:none;font-size:22px;font-weight:800;">Login with Modiway Advisor No</h2>

              <div v-if="isOtpActive">
                <div v-if="!!!isOtpSectionActive">
                  <div class="sc-gzOgki gmzccR sc-hwwEjo bWJFrR formik-input" style="position: relative;border-left: 0px;display: block;margin-bottom: 12px;">
                    <div wrap="nowrap" class="sc-htpNat gifjvn">
                      <input type="text" disabled="" class="sc-brqgnP kllRwb" value="+91" style="width: 50px;">
                      <input type="text" inputmode="tel" maxlength="10" name="contact" placeholder="Mobile number*" class="sc-brqgnP kllRwb" value="">
                    </div>
                  </div>
                  <!-- <input type="text" name="" placeholder="Mobile Number*" /> -->
                 <button class="btn btn-primary" @click="getOtp">Get OTP</button>
                </div>
                <div style="display:flex;justify-content:center;flex-direction:column;" v-if="isOtpSectionActive">
                  <div id="timer" v-if="timer > 0">Resend Otp in {{timer}} seconds</div>
                  <form action="" class="otp-form">
                    <input v-for="(input, index) in inputs" :key="index" v-model="inputs[index]" @input="digitValidate(index)" @keydown="handleKeydown($event, index)" maxlength="1" type="text" :ref="'input' + index"/>
                  </form>
                  <div>
                    <button class="btn btn-primary" style="float:left;" @click="submitOtp" >Verify</button>
                    <button id="resendButton" class="btn btn-primary" style="float:right;" :disabled="isButtonDisabled" @click="getOtp">Resend Code</button>
                  </div>
                </div>
              </div>
              <div v-else>
                <input type="text" name="" placeholder="MA No*" v-model="username" />
                <!-- {{ username }} -->
                <!-- <input type= "password" name="" placeholder="Password*" v-model="password"/> -->
                <div class="password-container">
                  <input
                    :type="passwordVisible ? 'text' : 'password'"
                    placeholder="Password*"
                    v-model="password"
                  />
                  <span @click="togglePasswordVisibility" class="eye-icon">
                    <i :class="passwordVisible ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
                  </span>
                </div>
                <!-- {{ password }} -->
                <button class="btn btn-primary" @click="signin">Sign In</button>
                <div>
                  <span class="signup">
                  <RouterLink to="/forgot-password-new" @click="toggleModal">Forgot Password </RouterLink>
                  <!-- <p style="color:red;">{{error}}</p> -->
                </span>
              </div>
              </div>
              <div class="not-register">
                <p class="signup">
                  Not Registered Yet ?
                  <RouterLink to="/register" @click="toggleModal">Sign Up.</RouterLink>
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
  </section>
    </div>
</template>

<style scoped>
.password-container {
  position: relative;
}

.eye-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.form-section{
  height: 365px;
  width: 320px;
}
.gifjvn {
    display: flex;
    flex-flow: row;
    gap:2px;
    -webkit-box-pack: initial;
    justify-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
}
.iMDNbs .formik-input input[value="+91"] {
    border-right: 0px;
}
.kllRwb {
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(220, 220, 220);
    width: 100%;
    padding: 10px;
    font-size: 0.9rem;
    appearance: none;
    border-radius: 0px;
    outline: none;
}
.login-options {
  display: flex;
  gap:10px;
  justify-content: space-between;
  position: relative;
  margin-bottom: 10px;
}
.not-register {
    /* bottom: 100px; Adjust as per desktop needs */
    left: 0;
    right: 0;
    position: fixed;
    padding-top:10px;
}

/* Tablet (Between 600px and 1024px) */
@media (max-width: 1024px) and (min-width: 600px) {
    .not-register {
        /* bottom: 100px; Adjust for tablet */
    }
}

/* Mobile (Up to 599px) */
@media (max-width: 599px) {
    .not-register {
        /* bottom: 150px; Mobile value (as you suggested) */
    }
}
.option {
  min-width:fit-content;
  flex: 1;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  color: #444;
  font-weight: bold;
  /* transition: color 0.4s, transform .3s ease, border-top .3s ease; */
}

.option.active {
  border-top:3px solid #276ca5;
  font-weight: bold;transform: translateY(-5px);
  /* transition: color 0.4s, transform .3s ease, border-top .3s ease; */
}

.slider {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 50%;
  background: #007bff;
  transition: transform 0.3s ease;
}

.slider.active-otp {
  transform: translateX(0%);
}

.slider.active-userid {
  transform: translateX(100%);
}

section {
  position: relative;
  min-height: 100vh;
  /* background-color: #f8dd30; */
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

section .container {
  position: relative;
  width: 400px;
  height: 450px;
  border-radius:15px;
  background: #fff;
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

section .container .user {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
}

section .container .user .imgBx {
  position: relative;
  width: 100%;
  height: 100%;
  background: transparent;
  transition: 0.5s;
}

section .container .user .imgBx img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

section .container .user .formBx {
  position: relative;
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction:column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  transition: 0.5s;
}

section .container .user .formBx form h2 {
  /* font-size: 18px;
  font-weight: 600; */
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  width: 100%;
  margin-bottom: 10px;
  color: #555;
}

section .container .user .formBx form input {
  position: relative;
  width: 100%;
  padding: 10px;
  background: #f2f2f2;
  border-radius: .75rem;
  color: #333;
  border: none;
  outline: none;
  box-shadow: none;
  margin: 8px 0;
  font-size: 14px;
  letter-spacing: 1px;
  /* font-weight: 300; */
}
.otp-form{
  display: flex;
  justify-content: center;
  gap:4px;
}
.otp-form input{
  display:inline-block !important;
  width:50px !important;
  height:50px !important;
  text-align:center !important;
}

/* section .container .user .formBx form input[type='submit'] {
  max-width: 100px;
  background: #677eff;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  transition: 0.5s;
} */

section .container .user .formBx form .signup {
  position: relative;
  margin-top: 20px;
  /* font-size: 12px; */
  /* margin-top:20px; */
  letter-spacing: 1px;
  color: #555;
  /* text-transform: uppercase; */
  /* font-weight: 300; */
}

section .container .user .formBx form .signup a {
  /* font-weight: 600; */
  text-decoration: none;
  color: #677eff;
}

section .container .signupBx {
  pointer-events: none;
}

section .container.active .signupBx {
  pointer-events: initial;
}

section .container .signupBx .formBx {
  left: 100%;
}

section .container.active .signupBx .formBx {
  left: 0;
}

section .container .signupBx .imgBx {
  left: -100%;
}

section .container.active .signupBx .imgBx {
  left: 0%;
}

section .container .signinBx .formBx {
  left: 0%;
}

section .container.active .signinBx .formBx {
  left: 100%;
}

section .container .signinBx .imgBx {
  left: 0%;
}

section .container.active .signinBx .imgBx {
  left: -100%;
}

@media (max-width: 991px) {
  section .container {
    max-width: 400px;
  }

  section .container .imgBx {
    display: none;
  }

  section .container .user .formBx {
    width: 100%;
  }
}
/* @media (max-width:768px){
  section .container{
    width: 99vw !important;
    height: 99vh !important;
  }
} */
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  transition: opacity 0.3s ease;
}

</style>
